import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, API } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const BrandingContext = createContext({
  company_name: "Production Pay Tracker",
  company_phone: "",
  company_logo_path: "",
  taxes_enabled_globally: false,
  job_photos_enabled: false,
  logoUrl: "",
  refresh: () => {},
});

export function BrandingProvider({ children }) {
  const { user } = useAuth();
  const [branding, setBranding] = useState({
    company_name: "Production Pay Tracker",
    company_phone: "",
    company_logo_path: "",
    taxes_enabled_globally: false,
    job_photos_enabled: false,
  });

  const refresh = useCallback(async () => {
    try {
      // Use the auth-aware `api` instance so the cookie is sent — the public
      // endpoint white-labels per tenant when the caller is signed in, and
      // returns generic "Production Pay Tracker" defaults when anonymous.
      const { data } = await api.get("/public/branding");
      setBranding(data);
    } catch (e) {
      // keep defaults
    }
  }, []);

  // Re-fetch whenever auth state changes (login, logout, super-admin tenant
  // switch). This is what prevents another tenant's name from sticking on
  // the sidebar after a fresh login.
  useEffect(() => {
    refresh();
  }, [refresh, user?.id, user?.company_id]);

  // The logo route is auth-aware (returns caller's tenant logo, 404 when
  // anonymous). Cache-bust by path so updates show immediately.
  const logoUrl = branding.company_logo_path
    ? `${API}/public/logo?v=${encodeURIComponent(branding.company_logo_path)}`
    : "";

  return (
    <BrandingContext.Provider value={{ ...branding, logoUrl, refresh }}>
      {children}
    </BrandingContext.Provider>
  );
}

export const useBranding = () => useContext(BrandingContext);
